<div class="loader-configuration-root">

  <div>
    <div class="loader-configuration-spinner-container">
      <mat-spinner
        color="accent"
        [diameter]="50"
      ></mat-spinner>
    </div>

    <div class="mat-body loader-configuration-text-container">
      {{text}}
    </div>
  </div>

</div>
